import { useToasteo } from '@deegital/vue-trustup-io-toasteo';

export default () => {
    const store = useAuthStore();

    const logout = async () => {
        useToasteoSuccess('auth.logout.success');
        useIntercom().shutdown();
        store.logout();
        await wait(500);
        return (window.location.href = '/');
    };

    return logout;
};
